import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// 路由配置
const routes = [
    {
        path: '/dramaPlayerBaseIos',
        name: 'dramaPlayerBaseIos',
        component: () => import('../pages/iosGround.vue')
    },
    {
        path: '/dramaPlayerBaseAndroid',
        name: 'dramaPlayerBaseAndroid',
        component: () => import('../pages/androidGround.vue')
    },
    {
        path: '/dramaPlayerHotDramaIos',
        name: 'dramaPlayerHotDramaIos',
        component: () => import('../pages/iosHotDramaGround.vue')
    },
    {
        path: '/404',
        name: '404',
        component: () => import('../pages/404.vue')
    },
    {
        path: '*',
        redirect: '/404'
    }
]

// 创建路由实例
const router = new VueRouter({
    mode: 'history', // 可选：hash/history
    base: process.env.BASE_URL,
    routes,
})

export default router